<template>
    <div class="calendar" :ref="calendar.calendarElement">
        <div class="calendar-header">
            <button type="button"
                    :class="calendar.getBackCSSClasses()"
                    v-bind="calendar.getBackAttrs()"
                    @click="calendar.goBack()"
                    v-html="calendarConfigModel.backHTML">
            </button>
            <div class="calendar-title" v-html="calendar.getCalendarMonth()"></div>
            <button type="button"
                    :class="calendar.getForwardCSSClasses()"
                    v-bind="calendar.getForwardAttrs()"
                    @click="calendar.goForward()"
                    v-html="calendarConfigModel.forwardHTML"
            ></button>
        </div>
        <div class="calendar-body" @mouseleave="calendar.handleMouseExitCalendar">
            <div class="calendar-week-days calendar-hide-mobile" v-once v-if="calendarConfigModel.showDaysOfWeek">
                <div v-for="day in calendarConfigModel.days" class="calendar-date--day">
                    <p>{{ day }}</p>
                </div>
            </div>
            <div class="slider-wrapper">
                <transition name="slider">
                    <div class="slide-item" :key="calendarConfigModel.calendarIndex">
                        <div class="calendar-week-dates">
                            <component :is="calendar.tagName"
                                       v-for="calendarDateModel in calendar.getCalendarDateModels()"
                                       @click.prevent="calendar.handleDateSelect(calendarDateModel)"
                                       @keyup.enter="calendar.handleDateSelect(calendarDateModel)"
                                       @mouseover="calendar.handleDateHover(calendarDateModel)"
                                       v-bind="calendarDateModel.getAttrs()">
                                <component :is="CalendarDate()" :calendarDateModel="calendarDateModel" />
                            </component>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
        <div class="calendar-footer">
            <button type="button"
                    :class="calendar.getBackCSSClasses()"
                    v-bind="calendar.getBackAttrs()"
                    @click="calendar.goBack()"
                    v-html="calendarConfigModel.backHTML">
            </button>
            <button type="button"
                    :class="calendar.getForwardCSSClasses()"
                    v-bind="calendar.getForwardAttrs()"
                    @click="calendar.goForward()"
                    v-html="calendarConfigModel.forwardHTML"
            ></button>
        </div>
    </div>
</template>
<script>
import CalendarController from "../Controllers/CalendarController.js";
import {onMounted} from "vue";
import CalendarConfigModel from "../Models/CalendarConfigModel.js";
import SelectedDatesModel from "../Models/SelectedDatesModel.js";
import MultiSelectedDatesModel from "../Models/MultiSelectedDatesModel.js";

export default {
    name: 'Calendar',
    props: {
        calendarConfigModel: {
            type: CalendarConfigModel,
            required: true
        },
        selectedDatesModel: {
            type: SelectedDatesModel,
            required: true
        },
        multiSelectedDatesModel: {
            type: MultiSelectedDatesModel,
            required: true
        }
    },
    /**
     * @param props
     * @param instance
     */
    setup(props, instance) {
        const calendar = new CalendarController(instance, props);

        onMounted(() => {
            calendar.handleMounted();
        });

        return {
            calendarConfigModel: calendar.calendarConfigModel,
            calendar,
            CalendarDate() {
                return calendar.calendarConfigModel.getCalendarDateComponent();
            }
        };
    }
}
</script>
